<template>
    <div class="patent-section">
        <div class="patent-title">多项国家技术专利和荣誉证书</div>
        <div class="patent-desc">
            <span class="highlight">2项</span> 发明专利，还有
            <span class="highlight">5项</span>在申请中
            <span class="highlight">12项</span>实用新型，
            <span class="highlight">13项</span>外观专利 伴生雾化软件著作权 跨界技术：雾化技术上升到新的 高度
        </div>
        <div class="patent-image">
            <img src="../assets/home27.png" alt="">
        </div>
    </div>
</template>

<script>
export default {
    name: 'PatentSection'
}
</script>

<style scoped>
.patent-section {
    background: #F5F6F7;
    padding: 0 15px;
}

.patent-title {
    font-weight: bold;
    font-size: 40px;
    color: #000000;
    text-align: center;
    padding: 90px 0 0 0;
}

.patent-desc {
    font-size: 18px;
    color: #000000;
    text-align: center;
    padding: 16px 0 0 0;
    line-height: 1.6;
}

.highlight {
    font-size: 20px;
    color: #B80708;
}

.patent-image {
    width: 100%;
    max-width: 1291px;
    height: auto;
    margin: 0 auto;
    padding: 65px 0;
}

.patent-image img {
    width: 100%;
    height: auto;
}

@media screen and (max-width: 768px) {
    .patent-title {
        font-size: 28px;
        padding: 40px 0 0 0;
    }

    .patent-desc {
        font-size: 16px;
        padding: 12px 0 0 0;
    }

    .highlight {
        font-size: 18px;
    }

    .patent-image {
        padding: 30px 0;
    }
}
</style> 